import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fb412770"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pa-2 d-flex flex-column align-center justify-center hv-100" }

import { AuthService } from '@/services/auth/authService';
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useToast } from 'vue-toast-notification';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const router = useRouter();
const authService = new AuthService();

const username = ref('');
const password = ref('');

const toast = useToast();

async function login() {
    const response = await authService.login(username.value, password.value);
    
    if (response?.accessToken) {
        localStorage.setItem('accessToken', response.accessToken);

        router.push({ name: 'home' });
        toast.success("Inicio de sesión correcto");
        return
    }

    toast.error("Usuario o contraseña incorrectos");
}

onMounted(() => {
    localStorage.removeItem('accessToken');
})

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, { width: "400px" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_title, null, {
          default: _withCtx(() => [
            _createTextVNode(" Iniciar sesión ")
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field, {
              variant: "outlined",
              density: "compact",
              label: "Usuario",
              type: "email",
              name: "email",
              "prepend-inner-icon": "mdi-account",
              modelValue: username.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((username).value = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_v_text_field, {
              variant: "outlined",
              density: "compact",
              label: "Contraseña",
              type: "password",
              name: "password",
              "prepend-inner-icon": "mdi-lock",
              modelValue: password.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
              onKeyup: _withKeys(login, ["enter"])
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_actions, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              variant: "tonal",
              block: "",
              color: "primary",
              onClick: login,
              disabled: !username.value || !password.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Iniciar sesión ")
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})